module.exports = __webpack_public_path__ + "img/fig17.c148ae53.jpg";